export default {
  Validate: {
    ComfirmDeleteOpeningSupplyEntryTitle: 'Xóa số dư CCDC',
    ComfirmDeleteOpeningSupplyEntry:
      'Bạn có muốn chắc chắn xóa số dư cho CCDC <span class="color-green">{0} - {1}</span> không?',
  },
};
